import React from "react";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FutureVisionCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="3244" id="request-your-free-site-visit" ref={ref} className={`dark bg-[hsl(215,25%,8%)] text-foreground py-24 overflow-hidden relative transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-white tracking-tight mb-6 leading-[1.1]">
              Get Your Quote Today
            </h2>
            <p className="text-lg md:text-xl font-default text-muted-foreground mb-10 max-w-lg leading-relaxed">
              Call <span className="text-primary font-bold">(925) 529-5005</span> for a free site visit. Let PCH Builders transform your outdoor space with expert craftsmanship.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="h-14 px-8 rounded-sm text-lg font-default bg-primary hover:bg-primary/90 text-primary-foreground shadow-[0_0_20px_-5px_var(--color-primary)] hover:shadow-[0_0_30px_-5px_var(--color-primary)] transition-all duration-300 group">
                <Link to="#">
                  <Sparkles className="w-5 h-5 mr-2 group-hover:animate-pulse" />
                  Request Free Site Visit
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative mt-12 lg:mt-0 perspective-[2000px] group">
            {}
            <div className="absolute inset-0 bg-primary/20 blur-3xl -z-10 rounded-full opacity-60 scale-90 translate-y-10" />

            {}
            <div className="relative rounded-sm border border-white/10 bg-card/5 backdrop-blur-sm shadow-2xl transition-transform duration-700 ease-out will-change-transform hover:[transform:perspective(2000px)_rotateY(-8deg)_rotateX(2deg)] [transform:perspective(2000px)_rotateY(-12deg)_rotateX(6deg)]">
              {}
              <div className="h-8 border-b border-white/5 flex items-center px-4 gap-2 bg-white/5 rounded-t-sm">
                <div className="w-3 h-3 rounded-full bg-red-500/80" />
                <div className="w-3 h-3 rounded-full bg-yellow-500/80" />
                <div className="w-3 h-3 rounded-full bg-green-500/80" />
              </div>
              
              {}
              <div className="p-1">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/deck_quote_form_interface.png" alt="PCH Builders Project Quote Interface" className="w-full h-auto rounded-b-sm rounded-t-sm shadow-inner" />
              </div>

              {}
              <div className="absolute -bottom-6 -left-6 bg-card border border-white/10 p-4 rounded-sm shadow-xl flex items-center gap-3 animate-bounce [animation-duration:3s]">
                <div className="bg-primary/20 p-2 rounded-full">
                  <Sparkles className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <div className="text-xs text-muted-foreground font-default font-medium">Project Status</div>
                  <div className="text-sm font-default font-bold text-white">Analyzing Site Data...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}